import { ChangeEvent, useCallback, useEffect, useState } from 'react'
import { useDebounce } from '../../../../hooks/useDebounce'

// TextCell と EmailCell で共通のテキスト入力ロジック（ローカル state ＋
// debounce 反映）。両セルで同じ配線を重複させないために切り出している。
export const useDebouncedTextInput = (
  value: string | undefined,
  onChange?: (v: string | undefined) => void
): {
  inputValue: string | undefined
  onChangeInput: (e: ChangeEvent<HTMLInputElement>) => void
} => {
  const [inputValue, setInputValue] = useState<string | undefined>(value)
  const [changedByInput, setChangedByInput] = useState<boolean>(false)
  useEffect(() => {
    setInputValue(value)
    setChangedByInput(false)
  }, [value])
  const debouncedValue = useDebounce(inputValue, 300)
  useEffect(() => {
    if (changedByInput) {
      onChange && onChange(debouncedValue)
    }
  }, [changedByInput, debouncedValue, onChange])
  const onChangeInput = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value)
    setChangedByInput(true)
  }, [])

  return { inputValue, onChangeInput }
}
